import { ITheme } from '@fluentui/react/lib/Styling';
import { ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { getStandardControlSemanticColorsWithTheme } from '@1js/acui-common';

export const getRibbonInputStyles = memoizeFunction(
  (theme: ITheme, width?: number): Partial<ITextFieldStyles> => {
    const widthToUse = width || 130;
    return {
      root: {
        height: 40,
        marginRight: 8,
        display: 'flex',
        alignItems: 'center',
      },
      wrapper: {
        display: 'flex',
      },
      fieldGroup: {
        height: 28,
        display: 'flex',
        alignItems: 'center',
        marginLeft: 10,
        background: getStandardControlSemanticColorsWithTheme(theme).defaultBackgroundColor,
      },
      field: {
        height: 24,
        width: widthToUse,
        paddingLeft: 4,
        paddingRight: 0,
      },
    };
  }
);
